import { render } from "./ProductMovement.vue?vue&type=template&id=78a4d1fc"
import script from "./ProductMovement.vue?vue&type=script&lang=js"
export * from "./ProductMovement.vue?vue&type=script&lang=js"
script.render = render

export default script